module.exports = __webpack_public_path__ + "media/images/talent/mv-slider11-e6433b9d6ad1d8092b65e480506a40c8.png";